/**
 * ConnectCreditPanel — dashboard credit-connect surface.
 *
 * Phase F1 (Credit Upload Lockdown, IdentityIQ Exclusive) rewrites this
 * component to render an IdentityIQ-exclusive connect card. All competitor
 * provider chips (SmartCredit, MyFICO, Credit Karma, MyScoreIQ, Credit
 * Hero, AnnualCreditReport.com, etc.) are removed from user-facing surfaces.
 *
 * The admin-editable `credit_hero_referral_url` field on `SiteSettings` is
 * intentionally left untouched in the backend data model — it simply is
 * not rendered anywhere in the user experience anymore.
 */
import React from "react";

import IdentityIQConnectCard from "@/components/credit/IdentityIQConnectCard";

export default function ConnectCreditPanel() {
  return (
    <IdentityIQConnectCard
      variant="dashboard"
      testIdPrefix="dashboard-connect-credit"
    />
  );
}
